import { get } from 'lodash';
import {
  VIEW_MODE_EDITOR,
  VIEW_MODE_PREVIEW,
  fetchWixData,
  fetchWixDataSuccess,
  type CommonThunkAction,
} from '@wix/communities-blog-client-common';
import Wix from '../services/wix-sdk-polyfill';

export const initWixData =
  ({
    viewMode,
    dataKeys,
    config,
  }: {
    viewMode?: unknown;
    dataKeys: string[];
    config?: unknown;
  }): CommonThunkAction<any> =>
  async (dispatch) => {
    const values = dataKeys.reduce<Record<string, unknown>>((acc, dataKey) => {
      acc[dataKey] = get(config, ['publicData', 'COMPONENT', dataKey], null);

      return acc;
    }, {});

    return dispatch(fetchWixDataSuccess(values));
  };
